module.exports = __webpack_public_path__ + "static/media/component-13.7d4a52bc.svg";